
define('text!modules/reporting/campaigns/siteTransparency/templates/grid_footer.html',[],function () { return '{{#pageControls}}\n<div class="page-controls">\n  <div class="page-count">\n    <span>\n      Showing <span data-bind="total_count">{{ total }}</span> Domains\n    </span>\n  </div>\n</div>\n{{/pageControls}}\n';});

